// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-cbb5aaa3","footer__text":"footer__text-c8935461","footerText":"footer__text-c8935461","bold":"bold-08529736"};